export default function BettingGuidesIcon() {
    return (
        <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">

            <path d="M11.516 20.5C11.516 18.5 12.5 17.5 14.5 17.5C16 17.5 20.5 17.5 20.5 17.5V1.5C20.5 1.5 15 1.5 14.5 1.5C12.5 1.5 11.5 2.5 11.5 4.5C11.5 2.5 10.5 1.5 8.5 1.5C8 1.5 2.5 1.5 2.5 1.5V17.5C2.5 17.5 7 17.5 8.5 17.5C10.5 17.5 11.516 18.5 11.516 20.5Z"></path>
            <path d="M20.5 3.5H22.5V19.5C22.5 19.5 18 19.5 16.5 19.5C14.5 19.5 13 20.5 13 22.5H10C10 20.5 8.5 19.5 6.5 19.5C5 19.5 0.5 19.5 0.5 19.5V3.5H2.5"></path>
            <path d="M11.5 4.5V20"></path>
        </svg>
    )
}